<template>
  <div class="form_item">
    <div>
      <Label :required="required" :label="label" :name="save_to"/>
      <masked-input
        :name="validationLabel || label"
        :key="save_to"
        :required="required"
        :id="save_to"
        type="text"
        :guide="false"
        v-model="ean"
        :mask="mask"
        :placeholder="placeholder"
        @blur.native="onBlur()"
        @change.native="onChange()"
        v-validate="rules"
      />
    </div>
    <span class="ean-valid" v-show="(val && options && options.length > 0 && val != ean)">✅ {{val}}</span>
    <p v-if="info !== undefined" class="info" v-html="info"></p>
    <span class="error" v-show="errors.has(validationLabel || label)" v-html="forceErrorMessage || errors.first(validationLabel || label)"></span>
  </div>
</template>

<script>
import MaskedInput from 'vue-text-mask';
import { validatorComponent } from './validatorComponentMixin';
import { customBlurMixin } from './customBlurMixin';

export default {
  name: 'EAN',
  components: { MaskedInput },
  mixins: [validatorComponent, customBlurMixin],
  props: {
    save_to: String,
    placeholder: String,
    required: Boolean,
    validationLabel: String,
    options: Array,
    _id : String,
  },
  data: function() {
    return {
      ean: ""
    }
  },
  computed: {
    rules() {
      if(this.options && this.options.length > 0) {
        let $in = this.options.map((o)=> {
          const label = o.label || o.name;
          const c1 = label.substring(0,1);
          const c2 = label.substring(1,7);
          const c3 = label.substring(7,13);
          return [c1, c2, c3].join(" ");
        });
        return {
          required: this.required,
          included: $in
        }
      }
      return {
        required: this.required,
        //securitesocialefr: true,
      }
    }
  },
  created() {
    if(this.options && this.options.length > 0) {
      const option = this.options.find((option)=>{
        return option.value == this.val;
      })
      if(option) {
        this.ean = option.label || option.name;
      } else {
        this.ean = "";
        this.val = "";
      }
    } else {
      this.ean = this.val;
    }
  },
  watch: {
    ean() {
      const ean = this.ean.split(' ').join('');
      if(ean.length == 13) {
        if(this.options && this.options.length > 0) {
          const option = this.options.find((option)=>{
            return option.label == ean || option.name == ean;
          })
          if(option) {
            this.val = option.value;
            this.$emit('input', option.value);
            return;
          }
        }else {
          this.val = ean;
          this.$emit('input', ean)
        }
      }
      this.val = "";
      this.$emit('input', "");
    }
  },
  methods: {

  },
  methods: {
    mask: function (rawValue) {
      return [/\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
    }
  }
};
</script>
